module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ExamView.js"));
	}, "DoExamView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DoExamView!./src/pages/Learn/Exam/ExamView.js
// module id = 2220
// module chunks = 367